import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const passcodeQuery = createApi({
  baseQuery,
  reducerPath: "passcodeQueries",
  endpoints: (builder) => ({
    getPasscode: builder.mutation<any, any>({
      query: ({ email }) => ({
        url: `${formatString(endPoints.forgotPassword.getPasscode, {
          key: urlKeys.email,
          value: email,
        })}`,
        method: "GET",
      }),
    }),
    resetPasscode: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.forgotPassword.resetPassword)}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const { useGetPasscodeMutation, useResetPasscodeMutation } =
  passcodeQuery;
